export const APP_VERSION = '1.0.21';
export const BUILD_DATE = '2025-06-05T07:17:25.332Z';
